import { Component, Injector, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { heldFinancialInstrumentsOptions } from '@app/forms/subscription/services/ref';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'scpi-financial-instruments',
    templateUrl: './scpi-financial-instruments.component.html',
    styleUrls: ['./scpi-financial-instruments.component.scss'],
    standalone: false
})
export class ScpiFinancialInstrumentsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = heldFinancialInstrumentsOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    this.form
      .get('heldFinancialInstruments')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(value => {
        if (!value?.includes('AUTRES')) {
          this.form.get('heldFinancialInstrumentsOther').setValue(null);
        }
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  check(item) {
    return (
      item == 'AUTRES' &&
      this.form.get('heldFinancialInstruments')?.value?.includes('AUTRES')
    );
  }
}
